import { Avatar as AvatarC, type AvatarProps as AvatarCProps } from '@chakra-ui/react'
import { useState } from 'react'

import type { User as HasuraUser } from '@/client/services/hasura/generated/graphql'

import type { UserDetails } from '@/components/Worlds/types'

export default function AvatarBase({
  user,
  children,
  ...avatarProps
}: {
  user:
    | Pick<UserDetails, 'displayName' | 'avatarUrl'>
    | Pick<HasuraUser, 'virtual_display_name' | 'virtual_avatar_url'>
  children?: JSX.Element | null
} & AvatarCProps): JSX.Element {
  const [hasError, setHasError] = useState(false)

  const displayName = 'displayName' in user ? user.displayName : user.virtual_display_name
  const avatarUrl = 'virtual_avatar_url' in user ? user.virtual_avatar_url : user.avatarUrl

  return (
    <AvatarC
      name={`${displayName}`}
      src={avatarUrl ?? ''}
      onError={() => setHasError(true)}
      // This hack removes an extraneous border around the avatar
      bg={
        avatarUrl == null || avatarUrl.length === 0
          ? 'primary.solid'
          : hasError
            ? undefined
            : 'transparent'
      }
      color="primary.contrast"
      {...avatarProps}
    >
      {children}
    </AvatarC>
  )
}
